import shared from './shared';

export default () => {
  const carousels = document.querySelectorAll('.c-carousel');

  if (carousels.length < 1) {
    return;
  }

  [].forEach.call(carousels, carousel => {
    const carouselList = carousel.querySelector('.c-carousel__list');
    const carouselPrev = carousel.querySelector('.c-carousel__nav--prev');
    const carouselNext = carousel.querySelector('.c-carousel__nav--next');
    const carouselMore = carousel.querySelector('.c-carousel__more');

    const changeSlide = direction => {
      const itemRect = carouselList
        .querySelector('.c-carousel__item')
        .getBoundingClientRect();
      const itemWidth = itemRect.width;
      const scrollLeft =
        itemWidth *
        Math.round(
          (carouselList.scrollLeft +
            direction * carouselList.getBoundingClientRect().width) /
            itemWidth,
        );
      carouselList.scroll({ top: 0, left: scrollLeft, behavior: 'smooth' });
    };

    if (carouselMore !== null) {
      carouselMore.addEventListener('click', event => {
        event.preventDefault();
        carouselList.classList.add(shared.CSS.active);
        event.currentTarget.parentNode.removeChild(event.currentTarget);
      });
    }

    if (carouselPrev !== null) {
      carouselPrev.addEventListener('click', event => {
        event.preventDefault();
        changeSlide(-1);
      });
    }

    if (carouselNext !== null) {
      carouselNext.addEventListener('click', event => {
        event.preventDefault();
        changeSlide(1);
      });
    }
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/carousel.js